module.exports = __webpack_public_path__ + "static/img/使用.1d55d921.png";